module.exports = __webpack_public_path__ + "img/IRES_GmbH_sRGB_neg_white.04f0888c.png";